import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, flatMap } from 'rxjs/operators';
import { InspectionPlugin, Person } from '../../../shared/models';
import {
  ApiService,
  DataService,
  InspectionPluginService,
  LanguageService,
  PeopleService
} from '../../../shared/services';
import { InstallationBobstContactPluginFactoryService } from './bobst-contact-plugin-factory.service';

@Injectable()
export class InstallationBobstContactPluginService extends InspectionPluginService {
  ownerTypeKeys: any = [
    { value: 1, label: 'plugins.installation-bobst-contact.project-leader' },
    { value: 2, label: 'plugins.installation-bobst-contact.technician-name' },
    { value: 3, label: 'plugins.installation-bobst-contact.local-project-leader' },
    { value: 4, label: 'plugins.installation-bobst-contact.technical-support-specialist' },
    { value: 5, label: 'plugins.installation-bobst-contact.technical-support-manager' },
    { value: 6, label: 'plugins.installation-bobst-contact.area-services-manager' }
  ];

  functionKeys: any = [
    { value: 1, label: 'plugins.installation-bobst-contact.mechanican-technician' },
    { value: 2, label: 'plugins.installation-bobst-contact.electrical-technician' },
    { value: 3, label: 'plugins.installation-bobst-contact.electronics-technician' },
    { value: 4, label: 'plugins.installation-bobst-contact.helper' },
    { value: 5, label: 'plugins.installation-bobst-contact.instructor' },
    { value: 7, label: 'plugins.installation-bobst-contact.installation-site-leader' },
    { value: 8, label: 'plugins.installation-bobst-contact.process-specialist' },
    { value: 6, label: 'plugins.installation-bobst-contact.third-party' }
  ];

  ownerTypes = [];
  functions = [];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    protected peopleService: PeopleService,
    private contactFactory: InstallationBobstContactPluginFactoryService,
    private language: LanguageService
  ) {
    super(apiService, dataService, null, contactFactory);
    this.applyTranslations();
    this.language.onLanguageChange().subscribe(() => this.applyTranslations());
  }

  public updateContact(inspectionId: string, pluginId: string, contact: any): Observable<any> {
    return this._updateContact(inspectionId, pluginId, contact).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.updateInspectionContact(inspectionId, res.config);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getPeople(): Observable<Person[]> {
    return this.peopleService.getPeople();
  }

  public getPerson(id: string): Observable<Person> {
    return this.peopleService.getPerson(id);
  }

  getOwnerTypes() {
    return this.ownerTypes;
  }

  getFunctions() {
    return this.functions;
  }

  applyTranslations() {
    this.ownerTypes = [];
    this.functions = [];
    this.copyTranslationValues(this.ownerTypeKeys, this.ownerTypes, this.language);
    this.copyTranslationValues(this.functionKeys, this.functions, this.language);
  }

  private _updateContact(inspectionId: string, pluginId: string, contact: any): Observable<any> {
    return this.contactFactory.updateContact(inspectionId, pluginId, contact).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
